// antd 3 does `Icon.add(...Object.keys(allIcons).map(k => allIcons[k]))` over
// @ant-design/icons/lib/dist. Rolldown's CJS interop (Vite 8) adds an
// enumerable `default` to that module, antd treats it as an icon and throws
// at startup (blank page). A non-enumerable `default` of our own stops the
// injection and stays out of Object.keys(). Aliased in vite.config.mts; the
// ".js" specifier below keeps the alias from matching itself.
const icons = require("@ant-design/icons/lib/dist.js");

if (!Object.prototype.hasOwnProperty.call(icons, "default")) {
	Object.defineProperty(icons, "default", {
		value: icons,
		enumerable: false,
		configurable: true,
	});
}

module.exports = icons;
